export const SET_FORECAST_CASH_TO_EARNING_DATA = "SET_FORECAST_CASH_TO_EARNING_DATA"
export const SET_FORECAST_CASH_TO_EARNING = "SET_FORECAST_CASH_TO_EARNING"